import { useEffect, useState } from 'react';

/** 値が変わってから delayMs 静かになった時点の値。オートコンプリートの検索語に使う */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
